import ShipmentBranchWarehouseReducer, { SelectedWarehouse } from "@gtsanders/Store/Pages/CheckoutReviewAndSubmit/ShipmentBranchWarehouseReducer";
import ShipmentBranchWarehousesState from "@gtsanders/Store/Pages/CheckoutReviewAndSubmit/ShipmentBranchWarehousesState";
import GTSOrderUploadReducer from "@gtsanders/Store/Pages/OrderUpload/GTSOrderUploadReducer";
import GTSOrderUploadState from "@gtsanders/Store/Pages/OrderUpload/GTSOrderUploadState";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import OrderUploadState from "@insite/client-framework/Store/Components/OrderUpload/OrderUploadState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

export type GTSState = {
    orderUpload: GTSOrderUploadState,
    shipmentBranchWarehouses: ShipmentBranchWarehousesState,
} & ApplicationState;

(reducers as any).orderUpload = GTSOrderUploadReducer;
(reducers as any).shipmentBranchWarehouses = ShipmentBranchWarehouseReducer;
(reducers as any).selectedWarehouse = ShipmentBranchWarehouseReducer;
type GTSReducers = typeof reducers;


export type HandlerProps<Parameter, Props> = Props & {
    readonly parameter: Readonly<Parameter>;
    dispatch: StrictInputDispatch;
    getState: () => GTSState;
};
export type StrictInputDispatch = (
    action: GTSActions | ((dispatch: StrictInputDispatch, getState: () => GTSState) => void),
) => GTSActions;

/** The a basic step in a handler chain.  If the boolean value `false` is returned, the chain stops on that step. */
export type Handler<Parameter = {}, Props = {}> = (
    props: HandlerProps<Parameter, Props>,
) => false | void | Promise<false | void>;

/** An extension of Handler that adds a `result` property. */
export type HandlerWithResult<Parameter, Result, Props = {}> = Handler<
    Parameter,
    Props & {
        result: Result;
    }
>;

export type GTSActions = AnyAction | Parameters<GTSReducers[keyof GTSReducers]>[1];
